import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { PermissionsService } from '../services/permissions/permissions.service';

export const CAPTURE_DASHBOARD_PERMISSION = 'can_see_capture_dashboard';

export const captureDashboardGuard: CanActivateFn = () => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);
  return permissions
    .resolveMe()
    .pipe(
      map(() =>
        permissions.isMasterWhitelabel() &&
        (permissions.isMasterAdmin() ||
          permissions.hasPermission(CAPTURE_DASHBOARD_PERMISSION))
          ? true
          : router.createUrlTree(['/minhas-cameras']),
      ),
    );
};
